import gql from 'graphql-tag';

export const QUERY_MAIN_MENU = gql`
  query QUERY_MAIN_MENU {
    usr_cls_menu_item {
      code
      id
      id_parent
      route
      title
      icon
      order_num
    }
  }
`;

export const QUERY_MENU_STATE = gql`
  query QUERY_MENU_STATE($user_id: uuid!) {
    usr_tp_user_settings(
      where: {
        _and: [
          { id_user: { _eq: $user_id } }
          { name: { _eq: "menu-state" } }
          { module_name: { _eq: "any" } }
        ]
      }
      order_by: { time_create: desc }
    ) {
      id
      module_name
      settings
    }
  }
`;

export const UPSERT_MENU_STATE = gql`
  mutation upsertMenuStateWithOnConflict(
    $setting: usr_tp_user_settings_insert_input!
    $onConflict: usr_tp_user_settings_on_conflict
  ) {
    insert_usr_tp_user_settings_one(object: $setting, on_conflict: $onConflict) {
      id
      id_user
      name
      module_name
      settings
      settings_type
    }
  }
`;
